import { Checkbox as AntCheckbox, CheckboxProps as AntCheckboxProps } from 'antd';
import cn from 'classnames';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { BFC } from '@/shared/types';

type CheckboxProps = {
  checked: boolean;
  error?: boolean;
} & AntCheckboxProps;

export const Checkbox: BFC<CheckboxProps> = ({ checked, error, children, ...props }) => {
  return (
    <StyledCheckbox className={cn({ error })} checked={checked} {...props}>
      {children}
    </StyledCheckbox>
  );
};

export const StyledCheckbox = styled(AntCheckbox)`
  &&&.error .ant-checkbox-inner {
    border-color: ${COLORS.systemFlame200};
  }
`;
